// for lookups a 24 hour poll with 5 minutes of jitter to keep them from all firing at once should work
export const LOOKUP_POLLING_DELAY = 24 * 60 * 60 * 1000;
